import { Icon, Typography } from '@mui/material'
import { Box } from '@mui/system'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import UpskillTable from 'pages/approval-center/components/UpskillTable'
import { useLocation, useNavigate } from 'react-router'
import UpskillHeader from './UpskillHeader'

const UpskillProgressionCourseDetail = () => {
  const tableColumn = [
    {
      id: 1,
      Header: 'Progress',
      accessor: 'name',
      Cell: (props) => {
        const { value } = props

        return (
          <Box display="flex" alignItems="center">
            <Box
              width={45}
              height={45}
              borderRadius="50%"
              bgcolor="alternate.light"
              marginRight={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                sx={{
                  color: 'alternate.main',
                }}
              >
                {props?.row?.original?.icon}
              </Icon>
            </Box>

            <Box>
              <Typography variant="subtile1">{value}</Typography>
              {/* <Box display="flex" alignItems="center" columnGap={1}>
                <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle</Icon>
                <Typography variant="body2" color="light-gray-text.main">
                  Next Class: Wed, 20/02/2024
                </Typography>
              </Box> */}
            </Box>
          </Box>
        )
      },
    },
    {
      id: 2,
      Header: 'Status',
      accessor: 'progress',
      Cell: (props) => {
        const { value } = props
        const roundeOfNumber = (num) => {
          return Math.round(num)
        }

        return (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box display="flex" justifyContent="space-between" alignItems="center" gap={'8px'}>
              <Box
                sx={{
                  width: '300px',
                  position: 'relative',
                  height: '10px',
                  backgroundColor: 'gray-background.main',
                  borderRadius: '4.5px',
                }}
              >
                <Box
                  sx={{
                    width: `${roundeOfNumber(value)}%`,
                    position: 'absolute',
                    height: '100%',
                    backgroundColor: 'alternate.main',
                    borderRadius: '4.5px',
                  }}
                ></Box>
              </Box>
              <Typography variant="subtitle1" color="alternate.main">
                {roundeOfNumber(value)}%
              </Typography>
            </Box>
          </Box>
        )
      },
    },
  ]

  const location = useLocation()
  const state = location.state
  const name = state.name
  const profile_picture = state.profile_picture
  const designation = state.designation
  const course_name = state.course_name
  const progress_data = state.progress_data
  const navigate = useNavigate()
  const data = [
    {
      name: 'Attendance',
      progress: progress_data.attendance,
      icon: 'watch_later',
    },

    {
      name: 'Assignment',
      progress: progress_data.assignment,
      icon: 'assignment',
    },
  ]
  return (
    <>
      <DashboardContainer
        headerTitle={
          <Typography fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
            Upskill Progression
          </Typography>
        }
      >
        <Box sx={{ padding: '16px 24px' }}>
          <Box display="flex" alignItems="center" marginBottom={2}>
            <Typography
              // onClick={() => navigate(-1)}
              onClick={() => navigate(-2)}
              component="span"
              variant="h4"
              color="alternate.main"
              sx={{
                cursor: 'pointer',
              }}
            >
              Upskill Progression
            </Typography>
            <Icon>chevron_right</Icon>
            <Typography
              onClick={() => navigate(-1)}
              component="span"
              variant="h4"
              color="alternate.main"
              sx={{
                textTransform: 'capitalize',
                cursor: 'pointer',
              }}
            >
              {name}
            </Typography>
            <Icon>chevron_right</Icon>
            <Typography
              component="span"
              variant="h4"
              color="light-gray-text.main"
              sx={{
                textTransform: 'capitalize',
              }}
            >
              {course_name}
            </Typography>
          </Box>
          <Box mt={'40px'}>
            <UpskillHeader
              name={name}
              designation={designation}
              profile_picture={profile_picture}
            />
          </Box>
          <Box
            mt={'40px'}
            //   sx={{ borderTop: '1px solid', paddingTop: '4px', borderColor: 'gray-line.main' }}
          >
            <UpskillTable
              column={tableColumn}
              data={data ?? []}
              // nav="View"
              // onClick={changePage}
              sxHeader
              sxNav
              sxCell
              error={false}
              isLoading={false}
              type={'course progress'}
              // lastPage={upskillProgressionData?.last_page}
              // count={upskillProgressionData?.total}
              // page={page}
              // onPageChange={handleChangePage}
              // rowsPerPage={rowsPerPage}
              // onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        </Box>
      </DashboardContainer>
    </>
  )
}
export default UpskillProgressionCourseDetail
